import * as React from "react";
type Props = {
  className?: string,
};
function SvgSnowFlake({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-SnowFlake"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 9.17071V7.18021L8.40971 4.58993L9.60635 3.39328L11 4.78693V2H13V4.78621L14.3929 3.39328L15.5896 4.58993L13 7.1795V9.1707C13.3511 9.29481 13.6723 9.48244 13.9496 9.71978L15.7657 8.67125L16.7494 5L18.4287 5.44996L17.8949 7.44194L20.1603 6.13403L21.1603 7.86608L18.8943 9.17439L20.8873 9.70844L20.4374 11.3877L16.765 10.4037L14.95 11.4516C14.9828 11.6294 15 11.8127 15 12C15 12.1875 14.9828 12.3709 14.9499 12.5489L16.8378 13.6388L20.6202 12.6254L21.08 14.3414L19.0136 14.8951L21.1601 16.1343L20.1601 17.8664L18.0141 16.6274L18.5676 18.693L16.8516 19.1528L15.8383 15.3712L13.9492 14.2805C13.672 14.5177 13.351 14.7052 13 14.8293V16.8205L15.5896 19.4101L14.3929 20.6067L13 19.2138V22H11V19.2131L9.60635 20.6067L8.40971 19.4101L11 16.8198V14.8293C10.6489 14.7052 10.3278 14.5176 10.0505 14.2803L8.23537 15.3283L7.25151 19.0001L5.57224 18.5501L6.10614 16.5576L3.8398 17.8661L2.8398 16.134L5.10613 14.8256L3.11361 14.2917L3.56357 12.6124L7.23536 13.5963L9.05004 12.5486C9.01717 12.3707 9 12.1874 9 12C9 11.8128 9.01715 11.6295 9.04998 11.4518L7.16125 10.3613L3.37904 11.3747L2.91924 9.65874L4.98544 9.1051L2.83948 7.86613L3.83948 6.13408L5.98518 7.37291L5.43165 5.30711L7.14766 4.84731L8.16099 8.62911L10.0503 9.71989C10.3276 9.4825 10.6488 9.29483 11 9.17071ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgSnowFlake;
